export default "__VITE_ASSET__BmNYCTIS__"